import React, { memo } from 'react'

import * as S from '../style'

type PropsInput = {
  id: number
  label: string
  value: string
  requiredFlag: boolean
  onChange: (value: string) => void
  'data-dg-id'?: string
}

const ImportExportInputRow: React.FC<PropsInput> = ({
  id,
  label,
  value,
  onChange,
  requiredFlag,
  'data-dg-id': dataDgId,
}) => {
  return (
    <>
      <S.SelectInputWrapper data-dg-id={dataDgId}>
        <S.RequiredText data-dg-id={`entry-load-page-required-${id}`}>{requiredFlag && '必須'}</S.RequiredText>
        <div
          style={{ width: 145 }}
          className="label"
          data-dg-id={`entry-load-page-label-${id}`}>
          {label}
        </div>
        <div style={{ width: 255 }}>
          <S.InputImportExport
            data-dg-id={`entry-load-page-input-${id}`}
            type="text"
            className="w-100"
            value={value}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              onChange(e.target.value)
            }}
          />
        </div>
      </S.SelectInputWrapper>
    </>
  )
}

export default memo(ImportExportInputRow)
